import React from 'react';

const defaultState: any = {
  notification: [],
};

const NotificationContext = React.createContext(defaultState);
const { Provider } = NotificationContext;

export { NotificationContext, Provider, defaultState };
